/* eslint-disable */
import { Route, BrowserRouter as BaseRoutes, Switch } from "react-router-dom";
import { useStores } from "./use.store";
import Splashscreen from "./pages/Splashscreen";
import { observer } from "mobx-react-lite";
import React from "react";
import Home from "./pages/Home";
import GetInfo from "./pages/GetInfo";
import Directory from "./pages/Directory";
import Happening from "./pages/Happening";

const Routes = observer(() => {
  return (
    <BaseRoutes>
      <Switch>
        <Route path="/" exact component={Home} />
      </Switch>
    </BaseRoutes>
  );
});

export default Routes;
